// Display filters never grant access: callers supply the already authorized team/events.
export function positiveDimension(value, fallback) {
  return value != null && value !== '' && Number.isFinite(Number(value)) && Number(value) > 0 ? Number(value) : fallback;
}

export function agendaWorkerColumnWidth(viewport, axis, count) {
  if (viewport > 760) return 180;
  const available = Math.max(156, viewport - axis - 16);
  if (count <= 1) return available;
  return viewport >= 375 ? Math.max(156, Math.floor(available / 2)) : 220;
}

export function resolveAgendaPermission(key, sources) {
  for (const source of sources) {
    const value = source?.[key];
    if (value == null) continue;
    // An explicit denial must not fall through to an older, permissive snapshot.
    return value === true || value === 1 || ['true', '1', 'yes', 'si', 'sí', 'on'].includes(String(value).trim().toLowerCase());
  }
  return false;
}

export function toggleAgendaWorker(selected, id, authorizedIds) {
  const allowed = [...new Set(authorizedIds.map(String))];
  if (!allowed.includes(String(id))) return selected;
  const current = selected?.length ? selected.map(String).filter(value => allowed.includes(value)) : allowed;
  const next = current.includes(String(id)) ? current.filter(value => value !== String(id)) : [...current, String(id)];
  // Empty means all in the existing calendar contract. Keep the final lane selected.
  return next.length ? next : current;
}

export function validAgendaRange(start, end) {
  return start instanceof Date && end instanceof Date && Number.isFinite(start.getTime()) && Number.isFinite(end.getTime()) && end > start;
}

export function authorizedAgendaWorkers(workers, permissions, ownId) {
  if (permissions.canViewAllCalendars === true) return workers;
  const selected = permissions.canViewSelectedCalendars === true ? new Set(permissions.allowedCalendarIds || []) : new Set();
  return workers.filter(worker => {
    const id = String(worker.id || worker.employeeId || '');
    return selected.has(id) || (permissions.canViewOwnCalendar !== false && ownId && id === String(ownId));
  });
}

export function agendaEventsForDay(events, day, resources) {
  const start = new Date(day); start.setHours(0, 0, 0, 0);
  const end = new Date(start); end.setDate(end.getDate() + 1);
  const ids = new Set(resources.map(resource => String(resource.id)));
  return events.filter(event => {
    // Calendar shading marks closed hours; it must never become a booking row.
    if (!event || ['background', 'inverse-background'].includes(event.display) || event.extendedProps?.kind === 'outside-hours') return false;
    const raw = event.extendedProps?.raw || event.raw || event.booking || {};
    const resource = String(event.resourceId || event.resourceIds?.[0] || event.extendedProps?.resourceId || raw.employeeId || raw.resourceId || raw.workerId || '');
    const at = new Date(event.start || event.startStr);
    return at >= start && at < end && (ids.has(resource) || (!resource && ids.has('__loop_company_agenda__')));
  }).sort((a, b) => new Date(a.start || a.startStr) - new Date(b.start || b.startStr));
}
